import { render } from "./ChampionsDetail.vue?vue&type=template&id=3f2fa9e5&scoped=true"
import script from "./ChampionsDetail.vue?vue&type=script&lang=js"
export * from "./ChampionsDetail.vue?vue&type=script&lang=js"

import "./ChampionsDetail.vue?vue&type=style&index=0&id=3f2fa9e5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2fa9e5"]])

export default __exports__